import React, { useState, useEffect } from 'react';
import { a2aAdminService } from '../../a2a/services/a2aAdminService.js';
import './UserManagementModule.css';

const UserManagementModule = ({ currentUser, onBack, onTabChange }) => {
  const [users, setUsers] = useState([]);
  const [filter, setFilter] = useState({ role: '', status: 'active' });
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchUsers();
  }, [filter]);

  const fetchUsers = async () => {
    setLoading(true);
    setError('');
    try {
      const tenantId = currentUser?.tenant_id || 'tn_01';
      const result = await a2aAdminService.listUsers({
        tenant_id: tenantId,
        ...filter
      });
      if (result.success) {
        setUsers(result.data || []);
      } else {
        setError(result.error || 'Failed to fetch users');
      }
    } catch (err) {
      setError(err.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  const handleCreateUser = () => {
    // TODO: Implement create user modal
    alert('Create user functionality coming soon');
  };

  const handleDeactivate = async (userId) => {
    if (!window.confirm('確定要停用此用戶嗎？')) {
      return;
    }
    // TODO: Implement deactivate user
    alert('Deactivate user functionality coming soon');
  };

  const handleUpdateUser = async (userData) => {
    // TODO: Implement update user
    alert('Update user functionality coming soon');
    setSelectedUser(null);
  };

  return (
    <div className="user-management-module">
      <div className="module-header">
        <button className="back-button" onClick={onBack}>← 返回</button>
        <h2>用戶管理</h2>
        <button className="create-button" onClick={handleCreateUser}>➕ 新增用戶</button>
      </div>
      
      <div className="filters">
        <select 
          value={filter.role} 
          onChange={(e) => setFilter({...filter, role: e.target.value})}
        >
          <option value="">所有角色</option>
          <option value="student">學生</option>
          <option value="teacher">教師</option>
          <option value="parent">家長</option>
          <option value="staff">職員</option>
          <option value="admin">管理員</option>
        </select>
        <select 
          value={filter.status} 
          onChange={(e) => setFilter({...filter, status: e.target.value})}
        >
          <option value="active">啟用</option>
          <option value="inactive">停用</option>
          <option value="all">全部</option>
        </select>
      </div>
      
      {error && <div className="error-message">{error}</div>}
      
      {loading ? (
        <div className="loading">載入中...</div>
      ) : (
        <div className="users-table">
          <table>
            <thead>
              <tr>
                <th>姓名</th>
                <th>角色</th>
                <th>電郵</th>
                <th>狀態</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              {users.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>
                    沒有找到用戶
                  </td>
                </tr>
              ) : (
                users.map(user => (
                  <tr key={user.id}>
                    <td>{user.name}</td>
                    <td>{user.role}</td>
                    <td>{user.email}</td>
                    <td>
                      <span className={`status-badge ${user.status}`}>
                        {user.status === 'active' ? '啟用' : '停用'}
                      </span>
                    </td>
                    <td>
                      <button 
                        className="edit-button"
                        onClick={() => setSelectedUser(user)}
                      >
                        編輯
                      </button>
                      <button 
                        className="deactivate-button"
                        onClick={() => handleDeactivate(user.id)}
                      >
                        停用
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
      
      {selectedUser && (
        <UserEditModal
          user={selectedUser}
          onClose={() => setSelectedUser(null)}
          onSave={handleUpdateUser}
        />
      )}
    </div>
  );
};

// Simple User Edit Modal Component
const UserEditModal = ({ user, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: user.name || '',
    email: user.email || '',
    role: user.role || 'student',
    status: user.status || 'active'
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ ...user, ...formData });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>編輯用戶</h3>
          <button className="close-button" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>姓名</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              required
            />
          </div>
          <div className="form-group">
            <label>電郵</label>
            <input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              required
            />
          </div>
          <div className="form-group">
            <label>角色</label>
            <select
              value={formData.role}
              onChange={(e) => setFormData({...formData, role: e.target.value})}
            >
              <option value="student">學生</option>
              <option value="teacher">教師</option>
              <option value="parent">家長</option>
              <option value="staff">職員</option>
              <option value="admin">管理員</option>
            </select>
          </div>
          <div className="form-group">
            <label>狀態</label>
            <select
              value={formData.status}
              onChange={(e) => setFormData({...formData, status: e.target.value})}
            >
              <option value="active">啟用</option>
              <option value="inactive">停用</option>
            </select>
          </div>
          <div className="modal-actions">
            <button type="button" onClick={onClose}>取消</button>
            <button type="submit">儲存</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserManagementModule;

